module.exports = __webpack_public_path__ + "static/media/square-portfolio.cfe693e0.jpg";